import React, {Component} from 'react';

import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {prepareSelectOptionsList,actionsFormatter,dateFormatter, customFormatter, getFieldByPathFormatter} from 'util/Utils';
import classNames from 'classnames';
import moment   from 'moment'
import config from  '../../../config';
import {UPDATE_ADMIN_PRODUCT, DELETE_ADMIN_PRODUCT,ADD_SELECTED_PRODUCTS,
    REMOVE_SELECTED_PRODUCTS} from "actions/actionTypes";

class SellerServiceListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        var isMobile = false;
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
            // true for mobile device
            isMobile = true
        }
        this.state = {
            isMobile:isMobile,
            perPage: config.table.numberPerPage,
            currentRecord:{},
        };

    }
    customActionsFormatter(cell, row, extra){
        var menuItemsMap  =    [ {customMenuItemClass:'menu-item-larger',  onClick: 'editRecord', label: 'Edit / Reschedule Service'} ,
            {customMenuItemClass:'menu-item-larger --last-item', onClick: 'cancelRecord', label: 'Cancel Service'},
            {customMenuItemClass:'menu-item-smaller', onClick: 'cancelRecord', label: 'What can I sell?'},
            {customMenuItemClass:'menu-item-smaller', onClick: 'cancelRecord', label: 'Seller Details'},
            {customMenuItemClass:'menu-item-smaller', onClick: 'cancelRecord', label: 'Email Us'}]
        return  actionsFormatter.call(this, cell, row, {menuItemsMap,buttonClass:'custom-menu',buttonIconClass:'glyphicon glyphicon-menu-hamburger'})
    }
    editRecord(row){
        this.props.editRecord(row);
    }
    cancelRecord(row){
        this.props.cancelRecord(row);
    }


    formatTimeWindow(cell, row, extra){
        if (row.TimeWindow &&  row.Type) {
            var foundItem = _.find(config.services.timeWindowOptions, {value: row.TimeWindow})
            return foundItem ? foundItem.label : row.TimeWindow;
        } else{
            return ''
        }
    }
    formatSize(cell, row, extra){
        if (row.Size &&  row.Type) {
            var foundItem = _.find(config.services[row.Type.toLowerCase()].sizeOptions, {value: row.Size})
            return foundItem ? foundItem.internalLabel : row.Size;
        }else{
            return ''
        }
    }




    render() {
            // console.log('state', this.state  );
        return (
            <div className=" databases-table customer-services-table">
                <BootstrapTable data={this.props.sellerServices.data} ref='table'
                                remote={ true }
                                hover={true}
                                condensed={true}
                                striped={true}
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange
                                } }

                >
                    {!this.state.isMobile &&
                    <TableHeaderColumn width="120px"
                                       dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['getObject'], format: (row) => {


                                               return <div className={ classNames({
                                                   'green': _.get(row, 'Status') == 'Complete',
                                                   'yellow': _.get(row, 'Status') == 'Scheduled',
                                                   'red': _.get(row, 'Status') == 'Cancelled',
                                               })}>
                                                   {_.get(row, 'Status')}
                                               </div>
                                           }
                                       }} dataAlign="center" dataSort={false}>Status</TableHeaderColumn>
                    }
                    {!this.state.isMobile &&
                    <TableHeaderColumn width="40px" dataField="ServiceStartTime" dataAlign="center"
                                       dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['getObject'], format: (row) => {
                                               return <div className="text-bold">
                                                   {moment(_.get(row, 'ServiceStartTime')).format('DD MMMM, YYYY')}
                                               </div>
                                           }

                                       }}


                                       dataSort={true}>Date</TableHeaderColumn>
                    }
                    {!this.state.isMobile &&
                    <TableHeaderColumn width="45px" dataAlign="center" dataField='Type'
                                       dataFormat={ customFormatter } formatExtraData={ {
                        path: ['Type'], path2: ['Status'], format: (value, arg2) => {
                            return _.get( _.find(config.services.serviceTypesMap,  {value:value}),'label','')
                        }
                    }}
                                       dataSort={true}>Type</TableHeaderColumn>
                    }
                    {/*<TableHeaderColumn width="55px" dataFormat={this.formatTimeWindow.bind(this)}  dataField='TimeWindow' dataAlign="center" dataSort={true}>Time</TableHeaderColumn>*/}
                    {/*<TableHeaderColumn width="40px" dataAlign="center" dataField='Size'  dataFormat={this.formatSize.bind(this)}*/}
                                        {/*dataSort={true}>Size</TableHeaderColumn>*/}
                    {!this.state.isMobile &&
                    <TableHeaderColumn width="110px"
                                       dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['getObject'], format: (row) => {
                                               if (row.Type == 'Pickup') {

                                                   return <div>
                                                       {_.get(row, 'PickupAddress.FullAddress')}
                                                   </div>
                                               } else {
                                                   const {WarehouseAddress=''} =  this.props.marketSettings[row.MarketName] ?  this.props.marketSettings[row.MarketName]:{}
                                                    return <div>
                                                       {WarehouseAddress}
                                                   </div>
                                               }

                                           }
                                       }} dataAlign="center" dataSort={true}>Location</TableHeaderColumn>
                    }
                    {this.state.isMobile &&
                    <TableHeaderColumn className="col-hidden" width="90px"
                                       dataFormat={ customFormatter }
                                       formatExtraData={{
                                           path: ['getObject'], format: (row) => {
                                               const {WarehouseAddress=''} =  this.props.marketSettings[row.MarketName] ?  this.props.marketSettings[row.MarketName]:{}

                                               return <div className="pleft10 bot20" style={{textAlign:'left'}}>
                                                   <div>
                                                   <span className={ classNames({
                                                       'green': _.get(row, 'Status') == 'Complete',
                                                       'yellow': _.get(row, 'Status') == 'Scheduled',
                                                       'red': _.get(row, 'Status') == 'Cancelled',
                                                   })}> {_.get(row, 'Status')}</span>
                                                       <span className="pleft5 pright5"> &#8226; </span>
                                                       <span>{_.get( _.find(config.services.serviceTypesMap,  {value:_.get(row, 'Type')}),'label','')}</span>
                                                   </div>

                                                   <div>
                                                       {row.Type == 'Pickup' ? _.get(row, 'PickupAddress.FullAddress') : WarehouseAddress}}
                                                   </div>
                                               </div>


                                           }}} dataAlign="center" dataSort={true}>Location</TableHeaderColumn>
                    }
                    <TableHeaderColumn  dataField="_id" isKey={true} hidden={true} autoValue={ true }
                                        hiddenOnInsert>Id</TableHeaderColumn>

                    <TableHeaderColumn width="10px" dataAlign="center"
                                       columnClassName={'actions-column customer-services-actions-column'}
                                       dataFormat={ this.customActionsFormatter.bind(this) }>Actions</TableHeaderColumn>

                </BootstrapTable>
             </div>
        );
    }
}


export default SellerServiceListTable;
